import React from "react";
var List = function List(_ref) {
  var list = _ref.list;
  return /*#__PURE__*/React.createElement("datalist", {
    id: list.id
  }, list.data.map(function (option) {
    return /*#__PURE__*/React.createElement("option", {
      value: option,
      label: option,
      key: option
    });
  }));
};
export default List;